
export interface Question {
  id: number;
  question: string;
  options: string[];
  correctanswer: number;
  difficulty: "easy" | "medium" | "hard";
  category: string;
  subject: string;
  explanation?: string;
  hint?: string;
  question_type: 'mcq' | 'fill_blank' | 'coding' | 'drag_drop';
  ai_generated: boolean;
}

export interface Category {
  name: string;
  subjects: string[];
}

export const categories: Category[] = [
  {
    name: "JEE Genius (IIT-JEE, Mains & Advanced)",
    subjects: ["Mathematics: Algebra", "Mathematics: Calculus", "Mathematics: Trigonometry", "Mathematics: Coordinate Geometry", 
               "Mathematics: Probability", "Physics: Mechanics", "Physics: Thermodynamics", "Physics: Optics", 
               "Physics: Electromagnetism", "Physics: Modern Physics", "Chemistry: Organic Chemistry", 
               "Chemistry: Inorganic Chemistry", "Chemistry: Physical Chemistry"]
  },
  {
    name: "NEET Mastery (Medical Entrance)",
    subjects: ["Biology- Part 1", "Biology- Part 2", 
               "Chemistry: Organic Chemistry", "Chemistry: Inorganic Chemistry", "Chemistry: Physical Chemistry",
               "Physics: Mechanics", "Physics: Thermodynamics", "Physics: Optics", "Physics: Modern Physics"]
  },
  {
    name: "MedMastery",
    subjects: ["Anatomy & Physiology", "Pathology", "Pharmacology", "Microbiology", 
               "Biochemistry", "Medical Ethics", "Clinical Diagnosis", "Immunology", 
               "Endocrinology", "Neurology"]
  },
  {
    name: "GATE Pathfinder",
    subjects: ["Computer Science: Data Structures & Algorithms", "Computer Science: Operating Systems", 
               "Computer Science: Networks", "Computer Science: Programming", "Computer Science: Digital Logic", 
               "Computer Science: Computer Organization and Architecture", "Computer Science: Theory of Computation", 
               "Computer Science: Compiler Design", "Computer Science: Databases", 
               "Computer Science: Information Systems and Software Engineering", "Computer Science: Web Technologies",
               "Mechanical Engineering: Statics", "Mechanical Engineering: Dynamics", 
               "Mechanical Engineering: Mechanics of Materials", "Mechanical Engineering: Theory of Mechanisms", 
               "Mechanical Engineering: Machine Components", "Mechanical Engineering: Theory of Vibration", 
               "Mechanical Engineering: Principles of Heat Transfer", "Mechanical Engineering: Fluid Dynamics", 
               "Mechanical Engineering: Control", "Mechanical Engineering: Differential Equations and Systems of Differential",
               "Electrical Engineering: Estimation of Plant Electrical Load", "Electrical Engineering: Gas Turbine Driven Generators", 
               "Electrical Engineering: Synchronous Generators and Motors", "Electrical Engineering: Automatic Voltage Regulation", 
               "Electrical Engineering: Induction Motors", "Electrical Engineering: Transformers", 
               "Electrical Engineering: Switchgear and Motor Control Centres", "Electrical Engineering: Fuses", 
               "Electrical Engineering: Cables, Wires and Cable Installation Practices", 
               "Electrical Engineering: Hazardous Area Classification and the Selection of Equipment", 
               "Electrical Engineering: Fault Calculations and Stability Studies", 
               "Electrical Engineering: Protective Relay Coordination", "Electrical Engineering: Earthing and Screening", 
               "Electrical Engineering: Variable Speed Electrical Drivers", "Electrical Engineering: Harmonic Voltages and Currents", 
               "Electrical Engineering: Computer Based Power Management Systems", 
               "Electrical Engineering: Uninterruptible Power Supplies", "Electrical Engineering: Miscellaneous Subjects", 
               "Electrical Engineering: Preparing Equipment Specifications", 
               "Electrical Engineering: Generalised Theory of Electrical Machines",
               "Civil Engineering: Construction", "Civil Engineering: Environmental Engineering", 
               "Civil Engineering: Geotechnical Engineering", "Civil Engineering: Hydraulic Engineering", 
               "Civil Engineering: Materials Engineering", "Civil Engineering: Structural Engineering", 
               "Civil Engineering: Surveying Engineering", "Civil Engineering: Transportation Engineering",
               "Electronics & Communications: Fundamental Electrical Theory", 
               "Electronics & Communications: Properties of Materials and Components", 
               "Electronics & Communications: Properties of Passive Components", 
               "Electronics & Communications: Passive Electrical Circuit", 
               "Electronics & Communications: Electron Vacuum Devices", 
               "Electronics & Communications: Microwave Vacuum Devices", 
               "Electronics & Communications: Semiconductor Devices and Circuits", 
               "Electronics & Communications: Microelectronics", "Electronics & Communications: Optoelectronics", 
               "Electronics & Communications: Power Supplies and Regulation", 
               "Electronics & Communications: Packaging Electronic Systems", 
               "Electronics & Communications: Communication Principles", 
               "Electronics & Communications: Electromagnetic Radiation", 
               "Electronics & Communications: Information Recording and Storage", 
               "Electronics & Communications: Wired Communications Systems", 
               "Electronics & Communications: Wireless Communications Systems", 
               "Electronics & Communications: Radar and Radionavigation", 
               "Electronics & Communications: Control and Instrumentation Technology", 
               "Electronics & Communications: Computer Systems", 
               "Electronics & Communications: Signal Measurement Analysis and Testing", 
               "Electronics & Communications: Reliability Engineering", 
               "Electronics & Communications: Safety", 
               "Electronics & Communications: Engineering Management Standardization and Regulation"]
  },
  {
    name: "UPSC Visionary (Civil Services Exam)",
    subjects: ["General Studies: Indian Polity", "General Studies: Economy", "General Studies: Geography", 
               "General Studies: History", "General Studies: Science & Tech", "Civil Services Aptitude Test: CSAT"]
  },
  {
    name: "Govt Exam Wizard",
    subjects: [
      "Quantitative Aptitude: Arithmetic",
      "Reasoning: Verbal & Non Verbal",
      "English Language: Grammar & Vocabulary",
      "General Awareness: GK"
    ]
  },
  {
    name: "Data Science Ace",
    subjects: ["Mathematics for AI: Linear Algebra", "Mathematics for AI: Probability", "Mathematics for AI: Statistics", 
               "Machine Learning: Supervised Learning", "Machine Learning: Unsupervised Learning", 
               "Machine Learning: Neural Networks", "Big Data & Analytics: Hadoop", "Big Data & Analytics: Spark", 
               "Big Data & Analytics: Data Engineering Fundamentals"]
  },
  {
    name: "Coding Maestro",
    subjects: ["Programming Languages: Python", "Programming Languages: Java", "Programming Languages: C++", 
               "Programming Languages: JavaScript", "Data Structures & Algorithms: Graphs", 
               "Data Structures & Algorithms: Trees", "Data Structures & Algorithms: Dynamic Programming", 
               "Competitive Coding: Code Optimization", "Competitive Coding: Problem-Solving Strategies"]
  },
  {
    name: "CyberSecure Pro",
    subjects: ["Ethical Hacking: Penetration Testing", "Ethical Hacking: Network Security", "Ethical Hacking: Cryptography", 
               "Cyber Threats: Malware Analysis", "Cyber Threats: Cyber Forensics", "Cyber Threats: Security Policies", 
               "Blockchain Security: Smart Contracts", "Blockchain Security: Consensus Mechanisms"]
  },
  {
    name: "Cloud Architect",
    subjects: ["Cloud Computing: AWS", "Cloud Computing: Azure", "Cloud Computing: Google Cloud Basics", 
               "DevOps: CI/CD Pipelines", "DevOps: Kubernetes", "DevOps: Docker", 
               "Networking & Security: Firewalls", "Networking & Security: Cloud Security Architecture"]
  },
  {
    name: "Banking Whiz",
    subjects: [
      "Quantitative Aptitude: Arithmetic",
      "Reasoning: Verbal & Non Verbal",
      "English Language: Grammar & Vocabulary",
      "General Awareness: GK",
      "Banking Awareness: BK"
    ]
  },
  {
    name: "Judiciary Mindset",
    subjects: ["Constitutional Law: Fundamental Rights", "Constitutional Law: Judiciary System", 
               "Criminal Law & IPC: Case Laws", "Contract Law: Business Laws", "Contract Law: Commercial Laws",
               "Legal Aptitude & Logical Reasoning", "Constitutional Framework: Supreme Court Cases"]
  },
  {
    name: "Teaching Excellence",
    subjects: ["Pedagogy & Learning Methods: Child Development", "Pedagogy & Learning Methods: Teaching Strategies", 
               "Subject-Specific Knowledge: Mathematics", "Subject-Specific Knowledge: Science", 
               "Subject-Specific Knowledge: Social Science", "Subject-Specific Knowledge: English", 
               "Education Policies & Reforms: NEP 2020", "Education Policies & Reforms: Inclusive Education"]
  },
  {
    name: "Stock Market Wizard",
    subjects: ["Stock Market Fundamentals: Technical Analysis", "Stock Market Fundamentals: Fundamental Analysis", 
               "Investment Strategies: Mutual Funds", "Investment Strategies: Risk Management", 
               "Financial Mathematics: Time Value of Money", "Financial Mathematics: Market Trends"]
  },
  {
    name: "Digital Marketing Pro",
    subjects: ["SEO & Content Strategy: Keyword Research", "SEO & Content Strategy: On-Page Optimization", 
               "Social Media Marketing: Facebook", "Social Media Marketing: Instagram", 
               "Social Media Marketing: LinkedIn Ads", "Data Analytics in Marketing: Google Analytics", 
               "Data Analytics in Marketing: Conversion Tracking"]
  },
  {
    name: "Supplementary Subjects",
    subjects: [
      "Computer",
      "Hindi"
    ]
  },
  {
    name: "NCERT Boost",
    subjects: [
      // History
      "History: Class 6 - Our Past I", 
      "History: Class 7 - Our Past II", 
      "History: Class 8 - Our Past III", 
      "History: Class 9 - India and the Contemporary World I", 
      "History: Class 10 - India and the Contemporary World II",
      "History: Class 11 - Themes in World History", 
      "History: Class 12 - Themes in Indian History",
      
      // Geography
      "Geography: Class 6 - The Earth: Our Habitat",
      "Geography: Class 7 - Our Environment",
      "Geography: Class 8 - Resource and Development",
      "Geography: Class 9 - Contemporary India I",
      "Geography: Class 10 - Contemporary India II",
      "Geography: Class 11 - Fundamentals of Physical Geography",
      "Geography: Class 11 - India: Physical Environment",
      "Geography: Class 12 - Fundamentals of Human Geography",
      "Geography: Class 12 - India: People and Economy",
      
      // Political Science / Polity
      "Political Science: Class 6 - Social & Political Life I",
      "Political Science: Class 7 - Social & Political Life II",
      "Political Science: Class 8 - Social & Political Life III",
      "Political Science: Class 9 - Democratic Politics I",
      "Political Science: Class 10 - Democratic Politics II",
      "Political Science: Class 11 - Indian Constitution at Work",
      "Political Science: Class 11 - Political Theory",
      "Political Science: Class 12 - Contemporary World Politics",
      "Political Science: Class 12 - Politics in India Since Independence",
      
      // Economics
      "Economics: Class 9 - Introduction to Economics",
      "Economics: Class 10 - Understanding Economic Development",
      "Economics: Class 11 - Indian Economic Development",
      "Economics: Class 12 - Introductory Microeconomics",
      "Economics: Class 12 - Introductory Macroeconomics",
      
      // Science
      "Science: Class 6",
      "Science: Class 7",
      "Science: Class 8",
      "Science: Class 9",
      "Science: Class 10",
      "Science: Class 11 - Physics",
      "Science: Class 11 - Chemistry",
      "Science: Class 11 - Biology",
      "Science: Class 12 - Physics",
      "Science: Class 12 - Chemistry",
      "Science: Class 12 - Biology"
    ]
  }
];

export const questions: Question[] = [
  {
    id: 1,
    category: "UPSC Visionary (Civil Services Exam)",
    subject: "Geography",
    question: "What is the capital of France?",
    options: ["London", "Berlin", "Paris", "Madrid"],
    correctanswer: 2,
    difficulty: "medium",
    explanation: "Paris is the capital and largest city of France.",
    hint: "This city is known as the 'City of Light'",
    question_type: "mcq",
    ai_generated: false
  },
  {
    id: 2,
    category: "UPSC Visionary (Civil Services Exam)",
    subject: "Geography",
    question: "Which is the largest ocean on Earth?",
    options: ["Atlantic", "Indian", "Pacific", "Arctic"],
    correctanswer: 2,
    difficulty: "easy",
    explanation: "The Pacific Ocean is the largest and deepest ocean on Earth.",
    question_type: "mcq",
    ai_generated: false
  },
  {
    id: 3,
    category: "UPSC Visionary (Civil Services Exam)",
    subject: "Science",
    question: "What is the chemical symbol for gold?",
    options: ["Ag", "Au", "Fe", "Cu"],
    correctanswer: 1,
    difficulty: "medium",
    explanation: "Au (from Latin 'aurum') is the chemical symbol for gold.",
    question_type: "mcq",
    ai_generated: false
  },
  {
    id: 4,
    category: "Engineering & Technology",
    subject: "Machine Learning",
    question: "Which of these is not a type of machine learning?",
    options: ["Supervised Learning", "Unsupervised Learning", "Reinforcement Learning", "Mechanical Learning"],
    correctanswer: 3,
    difficulty: "easy",
    explanation: "The three main types of machine learning are Supervised, Unsupervised, and Reinforcement Learning.",
    question_type: "mcq",
    ai_generated: false
  },
  {
    id: 5,
    category: "Government Exam Preparation",
    subject: "Quantitative Aptitude",
    question: "What is 15% of 200?",
    options: ["20", "25", "30", "35"],
    correctanswer: 2,
    difficulty: "easy",
    explanation: "15% of 200 = (15/100) × 200 = 30",
    question_type: "mcq",
    ai_generated: false
  }
];

export const getSubjects = (category: string): string[] => {
  const found = categories.find(c => c.name === category);
  return found ? found.subjects : [];
};

